var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7203 30.3795V36.4553C57.7203 48.1999 48.1994 57.7208 36.4549 57.7208M15.1895 30.3795V36.4553C15.1895 48.1999 24.7103 57.7208 36.4549 57.7208M36.4549 57.7208V66.8345M24.3032 66.8345H48.6065M36.4549 45.5691C31.4215 45.5691 27.3411 41.4887 27.3411 36.4553V15.1899C27.3411 10.1565 31.4215 6.07617 36.4549 6.07617C41.4883 6.07617 45.5686 10.1565 45.5686 15.1899V36.4553C45.5686 41.4887 41.4883 45.5691 36.4549 45.5691Z",
    stroke: "white",
    strokeWidth: 6.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMic);
export default __webpack_public_path__ + "static/media/whiteMic.1a246b6176d99f272d195f0d6715a0c1.svg";
export { ForwardRef as ReactComponent };